import isoDateToDate from 'src/utils/dateOperations/isoDateToDate';
import Vue from 'vue';
import DateInput from './DateInput.vue';
import { invokeOrVoid } from 'src/utils';
import Tooltip from '../Tooltips/Tooltip.vue';
export default Vue.extend({
    components: { DateInput, Tooltip },
    props: {
        intervalObject: { type: Object },
        tooltipText: { type: String },
        inputHandler: { type: Function }
    },
    computed: {
        from() { var _a; return ((_a = this.intervalObject) === null || _a === void 0 ? void 0 : _a.from) || '1900-01-01'; },
        to() { var _a; return ((_a = this.intervalObject) === null || _a === void 0 ? void 0 : _a.to) || '2100-01-01'; },
        fromDateProps() {
            return {
                value: this.from,
                qDateProps: {
                    mask: 'YYYY-MM-DD',
                    options: (date) => {
                        const to = this.to;
                        const date2 = date.replace(/\//g, '-');
                        return !to || isoDateToDate(date2) <= isoDateToDate(to);
                    }
                }
            };
        },
        toDateProps() {
            return {
                value: this.to,
                qDateProps: {
                    mask: 'YYYY-MM-DD',
                    options: (date) => {
                        const from = this.from;
                        const date2 = date.replace(/\//g, '-');
                        const result = (!from || isoDateToDate(date2) >= isoDateToDate(from));
                        return result;
                    }
                }
            };
        }
    },
    methods: {
        handleRangeInput(newVal) {
            this.$emit('input', newVal);
            invokeOrVoid(this.inputHandler, newVal);
        },
        handleFromInput(newVal) {
            this.handleRangeInput({ from: newVal, to: this.to });
        },
        handleToInput(newVal) {
            this.handleRangeInput({ from: this.from, to: newVal });
        }
    }
});
